import { useContext } from 'react';

import { ChannelsContext } from '../contexts';
import { CHANNEL_TYPE_KEYS } from 'constants-channel';

export default function useCompanyId(): string | null {
  // NOTE: Using any to avoid TypeScript errors as ChannelsContext is currently untyped
  // no ticket exists to address this, not scheduled.
  const { primaryChannel, secondaryChannel } = useContext<any>(ChannelsContext);

  if (primaryChannel?.type === CHANNEL_TYPE_KEYS.Company) {
    return primaryChannel._id;
  }

  if (secondaryChannel?.type === CHANNEL_TYPE_KEYS.Company) {
    return secondaryChannel._id;
  }

  return null;
}
